import * as React from "react";

function Services(props) {
  return (
    <svg width={22} height={22} fill="none" {...props}>
      <path
        clipRule="evenodd"
        d="M11 1L1 6l10 5 10-5-10-5v0z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 16l10 5 10-5M1 11l10 5 10-5"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const ServicesIcon = React.memo(Services);
export default ServicesIcon;
